import BaseApi from '../baseApi'
export default {
  fetchAll() {
    return BaseApi.get('api-master-data/business-identifiers/v1');
  }
}
